import { createFileRoute } from '@tanstack/react-router'
import { OrderReviewPage } from '@/pages/order-review'

export const Route = createFileRoute('/_authenticated/order-review/')({
  staticData: { title: 'Order review' },
  component: OrderReviewPage,
})
